(() => {
  'use strict';
  function init(scope = document) {
    scope.querySelectorAll('[data-ps24-filter]').forEach(filter => {
      if (filter.dataset.ready) return;
      const container = filter.parentElement;
      const input = filter.querySelector('input');
      const entries = [...container.querySelectorAll('[data-ps24-entry]')];
      const empty = container.querySelector('[data-ps24-empty]');
      const count = filter.querySelector('[data-ps24-count]');
      if (!input || !entries.length) return;
      filter.dataset.ready = 'true';
      filter.hidden = false;
      const update = () => {
        const normalize = value => value.toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[\s&·-]+/g, '');
        const query = normalize(input.value.trim());
        let visible = 0;
        for (const entry of entries) {
          entry.hidden = !normalize(entry.dataset.name).includes(query);
          if (!entry.hidden) visible++;
        }
        if (empty) empty.hidden = visible !== 0;
        count.textContent = `${visible} / ${entries.length}`;
      };
      input.addEventListener('input', update);
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once: true});
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
